import { memo, useCallback } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function ContactConfirmation() {
  const navigate = useNavigate();

  const handleGoToDashboard = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  return (
    <main className="container p-4" aria-label="Contact confirmation">
      <div className="card shadow-lg border-0 rounded-2 text-center p-4">
        <h3 className="mb-3 text-success">
          <span aria-hidden="true">✅</span> Your message has been sent!
        </h3>
        <p>Thank you for reaching out. We&apos;ll get back to you shortly.</p>
        <Button
          type="button"
          variant="primary"
          className="btn-fit-content px-4"
          onClick={handleGoToDashboard}
        >
          Go to Dashboard
        </Button>
      </div>
    </main>
  );
}

ContactConfirmation.displayName = "ContactConfirmation";

export default memo(ContactConfirmation);
